import { render, staticRenderFns } from "./CoreTechnology.vue?vue&type=template&id=5f7e98f9&scoped=true&"
import script from "./CoreTechnology.vue?vue&type=script&lang=js&"
export * from "./CoreTechnology.vue?vue&type=script&lang=js&"
import style0 from "./CoreTechnology.vue?vue&type=style&index=0&id=5f7e98f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7e98f9",
  null
  
)

export default component.exports